
  (function () {
    const KLAVIYO_PUBLIC_API_KEY = 'T7Xd5g';
    // Strings come from locales via ff-main-product.liquid
    const strings = window.ffBackInStockStrings || {};

    function createBackInStockModal() {
      if (document.querySelector('#ff-klaviyo-bis-modal')) return;

      const modal = document.createElement('div');
      modal.id = 'ff-klaviyo-bis-modal';
      modal.innerHTML = `
        <div class="ff-klaviyo-bis-overlay" data-ff-klaviyo-bis-close></div>
        <div class="ff-klaviyo-bis-dialog" role="dialog" aria-modal="true">
          <button type="button" class="ff-klaviyo-bis-close" data-ff-klaviyo-bis-close aria-label="${strings.close}">×</button>
          <h2>${strings.title}</h2>
          <p>${strings.text}</p>
          <input type="email" class="ff-klaviyo-bis-email" placeholder="${strings.emailPlaceholder}">
          <button type="button" class="ff-klaviyo-bis-submit">${strings.submit}</button>
          <p class="ff-klaviyo-bis-message"></p>
        </div>
      `;
      document.body.appendChild(modal);
    }

    function openBackInStockModal(variantId) {
      createBackInStockModal();

      const modal = document.querySelector('#ff-klaviyo-bis-modal');
      modal.dataset.variantId = variantId;
      modal.classList.add('is-active');

      const emailInput = modal.querySelector('.ff-klaviyo-bis-email');
      const message = modal.querySelector('.ff-klaviyo-bis-message');

      emailInput.value = '';
      message.textContent = '';
      emailInput.focus();
    }

    function closeBackInStockModal() {
      const modal = document.querySelector('#ff-klaviyo-bis-modal');
      if (!modal) return;
      modal.classList.remove('is-active');
    }

    async function subscribeBackInStock(email, variantId) {
      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + variantId
              }
            }
          }
        }
      };

      const response = await fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_PUBLIC_API_KEY,
        {
          method: 'POST',
          headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
            'revision': '2026-04-15'
          },
          body: JSON.stringify(payload)
        }
      );

      if (response.status !== 202) {
        throw new Error('Klaviyo Back In Stock error');
      }
    }

    document.addEventListener('click', function (event) {
      const button = event.target.closest('.ff-main-product_purchase_submit[data-variant-id]');

      if (!button) return;
      if (button.getAttribute('type') !== 'button') return;

      event.preventDefault();

      openBackInStockModal(button.dataset.variantId);
    });

    document.addEventListener('click', async function (event) {
      const submitButton = event.target.closest('.ff-klaviyo-bis-submit');
      if (!submitButton) return;

      const modal = document.querySelector('#ff-klaviyo-bis-modal');
      const emailInput = modal.querySelector('.ff-klaviyo-bis-email');
      const message = modal.querySelector('.ff-klaviyo-bis-message');

      const email = emailInput.value.trim();
      const variantId = modal.dataset.variantId;

      if (!email || !emailInput.checkValidity()) {
        message.textContent = strings.invalidEmail;
        return;
      }

      submitButton.disabled = true;
      submitButton.textContent = strings.sending;
      message.textContent = '';

      try {
        await subscribeBackInStock(email, variantId);
        message.textContent = strings.success;
      } catch (error) {
        message.textContent = strings.error;
      } finally {
        submitButton.disabled = false;
        submitButton.textContent = strings.submit;
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-ff-klaviyo-bis-close]')) {
        closeBackInStockModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeBackInStockModal();
      }
    });
  })();
